module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"header":"Formas de Pagamento"},"en-US":{"header":"Payment Methods"}}')
  delete Component.options._Ctor
}
